import { useEffect } from "react"

import { trackEvent } from "@/lib/usageEvents"

/**
 * Открытие и закрытие модального окна. Ставится внутрь Content: сам DialogContent монтируется и
 * при закрытом окне, а содержимое Radix рисует только при открытом.
 */
const TrackedOpen = ({ trackId }) => {
  useEffect(() => {
    if (!trackId) {
      return undefined;
    }

    trackEvent(`${trackId}.open`);
    return () => trackEvent(`${trackId}.close`);
  }, [trackId]);

  return null;
};

export { TrackedOpen }
